import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <span className="App-title">sheincall</span>
      </header>
      <main className="App-main">
        <p className="App-maintenance">维护中...</p>
      </main>
      <footer className="App-footer">
        <p>版权所有：广州希音国际进出口有限公司</p>
        <p>
          ICP备案号：
          <a
            className="App-icp-link"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            rel="noopener noreferrer"
          >
            粤ICP备2023139467号-4
          </a>
        </p>
      </footer>
    </div>
  );
}

export default App;
